import { render, staticRenderFns } from "./appendix-visa.vue?vue&type=template&id=46ecfb2a&scoped=true"
import script from "./appendix-visa.vue?vue&type=script&lang=js"
export * from "./appendix-visa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ecfb2a",
  null
  
)

export default component.exports